﻿import { Subject } from 'rxjs';

export function isDefined<T>(item: T | undefined | null): item is T {
    return typeof item !== 'undefined' && item !== null;
}

export function isObject(o: any) {
    return typeof o === 'object' && o != null;
}

/** Type guard for filtering out undefined */
export function omitUndefinedElements<T>(item: T): item is NonNullable<T> {
    return item !== null && typeof item !== 'undefined';
}

export const changesProcessed = new Subject<void>();

export const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isGuid(str: string) {
    return guidRegex.test(str);
}

export const absoluteUrlRegex = /^(?:[a-z]+:)?\/\//i;
export function isAbsoluteUrl(url: string): boolean {
    return absoluteUrlRegex.test(url);
}

export function appendOrIncrementNumber(name: string) {
    const lastNumber = name.replace(/\D*(\d*)\s*$/, '$1');
    if (lastNumber === '') {
        return name + ' 2';
    } else {
        return name.replace(/\d*\s*$/, (parseInt(lastNumber, 10) + 1).toString());
    }
}

/** UUID generation based on:  https://github.com/jchook/uuid-random/blob/master/index.js */
export class UUID {
    private static buf: Uint8Array;
    private static bufIdx = 0;
    private static hexBytes = new Array<string>();
    private static i: number;
    private static bufferSize = 4096;

    public static initialize() {
        // Pre-calculate toString(16) for speed
        for (UUID.i = 0; UUID.i < 256; UUID.i++) {
            UUID.hexBytes[UUID.i] = (UUID.i + 0x100).toString(16).substr(1);
        }
    }

    // Buffer some random bytes for speed
    protected static randomBytesBuffered(n: number) {
        if (!UUID.buf || UUID.bufIdx + n > UUID.bufferSize) {
            UUID.bufIdx = 0;
            UUID.buf = crypto.getRandomValues(new Uint8Array(UUID.bufferSize));
        }
        return UUID.buf.slice(UUID.bufIdx, (UUID.bufIdx += n));
    }

    // uuid.bin
    protected static uuidBin() {
        const b = UUID.randomBytesBuffered(16);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        return b;
    }

    public static generate() {
        const b = UUID.uuidBin();
        return (
            UUID.hexBytes[b[0]] +
            UUID.hexBytes[b[1]] +
            UUID.hexBytes[b[2]] +
            UUID.hexBytes[b[3]] +
            '-' +
            UUID.hexBytes[b[4]] +
            UUID.hexBytes[b[5]] +
            '-' +
            UUID.hexBytes[b[6]] +
            UUID.hexBytes[b[7]] +
            '-' +
            UUID.hexBytes[b[8]] +
            UUID.hexBytes[b[9]] +
            '-' +
            UUID.hexBytes[b[10]] +
            UUID.hexBytes[b[11]] +
            UUID.hexBytes[b[12]] +
            UUID.hexBytes[b[13]] +
            UUID.hexBytes[b[14]] +
            UUID.hexBytes[b[15]]
        );
    }
}
UUID.initialize();
